<template>

	<div class="steps-bar clearfix">
		<div @click="step = step !== 4 ? 1 : 4" class="steps-bar-step steps-bar-step1" :class="{active: step == 1}"><div class="arrow-back"></div><div class="steps-bar-step-label">Крок 1</div><div class="steps-bar-step-desc">Товари в кошику</div><div class="arrow-front"></div></div>
		<div @click="step = step !== 4 ? 2 : 4" class="steps-bar-step steps-bar-step2" :class="{active: step == 2}"><div class="arrow-back"></div><div class="steps-bar-step-label">Крок 2</div><div class="steps-bar-step-desc">Контактні дані</div><div class="arrow-front"></div></div>
		<div v-if="(totalPrice && fullItems.length) || (!totalPrice && !fullItems.length && !demo)" @click="gotoStep3" class="steps-bar-step steps-bar-step3" :class="{active: step == 3}"><div class="arrow-back"></div><div class="steps-bar-step-label">Крок 3</div><div class="steps-bar-step-desc">Спосіб оплати</div><div class="arrow-front"></div></div>
	</div>
	<div v-if="step == 1" class="checkoutStep1">
		<div class="checkoutStep-content clearfix">
			<div class="items-list">
				<table>
					<thead>
						<tr>
							<th class="basketRemoveItem"></th>
							<th class="basketItemDescription">Товар</th>
							<th class="basketItemPrice">Ціна</th>
							<th class="periodSelector">Період передплати</th>
							<th class="quantitySelector">Кількість</th>
							<th class="wareItemTotal">Загальна сума</th>
						</tr>
					</thead>
					<tbody class="baket-items-list">
            <tr class="basket-item" v-for="item in fullItems" v-bind:key="item.id">
              <td @click="removeFromBasket(item)" class="basketRemoveItem removeItem">X</td>
              <td class="basketItemDescription">
                <img class="basket-item-image" :src="item.image" />
                <span class="basket-item-description">
									<span v-if="getTypeLabel(item.selectedPrice).length" class="basket-item-type">{{ getTypeLabel(item.selectedPrice) }}</span><br v-if="getTypeLabel(item.selectedPrice).length"/>
                  <span class="basket-item-title">{{ item.title }}</span>
                </span>
              </td>
              <td class="basketItemPrice">{{ item.price }} грн</td>
              <td class="periodSelector">
                <div class="ware-option ware-prepaytype">
                  <div class="prepay-options-value">{{ getPeriodLabel(item.selectedPrice) }}</div>
                </div>
              </td>
              <td class="quantitySelector">
                <div class="ware-option ware-quantity">
                  <div class="control-wrapper noselect">
                    <input maxlength="3" type="text" v-model="item.quantity" />
                    <span @click="incQuantity(item)" :class="{disabled: item.quantity==99}" class="quantity-button-inc">+</span>
                    <span @click="decQuantity(item)" :class="{disabled: item.quantity==1}" class="quantity-button-dec">−</span>
                  </div>
                </div>
              </td>
              <td class="wareItemTotal"><span class="wareTotal"></span>{{ item.quantity * item.price }} грн</td>
            </tr>
					</tbody>
				</table>
				<div class="basket-totals-block">
					<div class="basket-totals-label">Усього</div>
					<div class="basket-totals-sum"><span class="basket-totals-value"></span>{{ totalPrice }} грн</div>
					<div @click="step=!fullItems.length ? 1 : 2" :class="{disabled: !fullItems.length}" class="basket-button basket-button-to-step2 button btn-red">Оформити замовлення</div>
				</div>
			</div>
		</div>
	</div>
	<div v-if="step == 2" class="checkoutStep2">
		<div class="checkoutStep2-content clearfix">
			<div class="basket-customerType-wrapper">
				<label id="radioCustomerTypeIndividual" class="customerTypeLabel" for="CustomerTypeIndividual"><input type="radio" v-model="customerType" id="CustomerTypeIndividual" name="customerType" value="individual"/><span>Фізична особа</span></label>
				<label id="radioCustomerTypeEntity" class="customerTypeLabel" for="CustomerTypeEntity"><input type="radio" v-model="customerType" id="CustomerTypeEntity" name="customerType" value="entity"/><span>Юридична особа</span></label>
			</div>
			<div class="checkoutStep2-title">Контактні дані покупця</div>
			<div class="basket-form-wrapper">
				<form>
					<div class="text-input">
						<label>Ваше ім'я<span class="required">*</span></label><input v-model="customerName" type="text" placeholder="Введіть ім'я" />
						<span v-if="validating && !customerNameValid" class="error-message">Обов'язкове поле</span>
					</div>
					<div class="text-input">
						<label>Ваше прізвище<span class="required">*</span></label><input v-model="customerName2" type="text" placeholder="Введіть прізвище" />
						<span v-if="validating && !customerName2Valid" class="error-message">Обов'язкове поле</span>
					</div>
					<div class="text-input">
						<label>Мобільний телефон<span class="required">*</span></label><input v-mask="'+38 (###) ###-##-##'" v-model="phone" type="text" placeholder="+38 (098) 000-00-00" />
						<span v-if="validating && !phoneValid" class="error-message">Обов'язкове поле</span>
					</div>
					<div class="text-input">
						<label>Електронна пошта<span class="required">*</span></label><input v-model="email" type="text" placeholder="my_email@gmail.com" />
						<span v-if="validating && !emailValid" class="error-message">Помилковий email</span>
					</div>
					<div v-if="customerType=='entity'" class="text-input">
						<label>Назва організації<span class="required">*</span></label><input v-model="organization" id="customerOrganization" type="text" placeholder="Введіть назву організації" />
						<span v-if="validating && !organizationValid" class="error-message">Обов'язкове поле</span>
					</div>
					<div v-if="customerType=='entity'" class="text-input">
						<label>Код ЄДРПОУ<span class="required">*</span></label><input v-model="code" id="customerOrgCode" type="text" placeholder="0000000000" />
						<span v-if="validating && !codeValid" class="error-message">Обов'язкове поле</span>
					</div>
					<div v-if="customerType=='entity'" class="text-input">
						<label>Ваша посада<span class="required">*</span></label><input v-model="position" id="customerPosition" type="text" placeholder="Введіть посаду" />
						<span v-if="validating && !positionValid" class="error-message">Обов'язкове поле</span>
					</div>
					<div v-if="studentsCount" class="input-checkbox">
						<label id="checkboxStudent" for="student"><input v-model="imStudent" type="checkbox" id="student" name="student" /><span>Я учасник навчання</span></label>
					</div>
					<div v-for="student, index in students" class="formItem-studentFio text-input" v-bind:key="index">
						<label>Учасник №{{ index+1 }}<span class="required">*</span></label>
						<input :disabled="imStudent && index == 0" v-model="student.name" :name="'student' + (index+1)" type="text" :placeholder="'Прізвище та ім\'я учасника №' + (index+1)" />
						<span v-if="validating && !student.valid" class="error-message">Обов'язкове поле</span>
					</div>
					<div class="formItem-deliveryComment text-input">
						<label>Коментар</label><textarea v-model="comment" class="deliveryComment"></textarea>
					</div>
				</form>
			</div>
		</div>
		<div class="basket-totals-block">
			<div v-if="totalPrice" @click="gotoStep3" :class="{disabled: !fullItems.length}" class="basket-button basket-button-to-step3 button btn-red">До оплати</div>
			<div v-else @click="submitOrder" :class="{disabled: (!fullItems.length || submitting )}" class="basket-button basket-button-to-step3 button btn-red">Замовити</div>
		</div>
	</div>
	<div v-if="step == 3" class="checkoutStep3">
		<div class="checkoutStep3-content clearfix">

			<div class="input-checkbox">
				<label id="checkboxNeedBill" class="needBillLabel" for="needBill"><input type="checkbox" v-model="needBill" id="needBill" name="needBill" /><span>Мені потрібен договір</span></label>
			</div>
			<div class="checkoutStep2-title">Оплата</div>
			<div class="basket-payment-wrapper">
				<label id="radioBankPayment" class="paymentLabel" for="bankPayment"><input v-model="payment" type="radio" id="bankPayment" name="payment" value="bankPayment"/><span>Безготівкова оплата через банк</span></label>
				<label v-if="customerType == 'individual' && !hasUnsellableItems" id="radioCardPayment" class="paymentLabel" for="cardPayment"><input v-model="payment" type="radio" id="cardPayment" name="payment" value="cardPayment"/><span>Безготівкова оплата карткою ( Visa / MasterCard )</span></label>
			</div>

			<div class="payment-online-tip">
				<span v-if="payment=='cardPayment'" class="payment-online-tip-icon cardsIcon"></span><span class="payment-online-tip-text"></span>
			</div>

			<div class="payment-tip">
				<i class="icon icon-security"></i><span class="payment-tip-text">- Вся введена інформація на платіжних сторінках надійно захищена відповідно до міжнародних стандартів безпеки, зберігається у зашифрованому вигляді і ніколи не передається третім особам, за вийнятком випадів розкриття, передбачених законодавством України</span>
			</div>

			<div class="basket-privacy-policy">Оформлюючи замовлення, я погоджуюся з умовами <a target="_blank" href="/privacy-policy">Політики конфіденційності</a></div>
			<div class="basket-totals-block">
				<div @click="submitOrder" :class="{disabled: (!fullItems.length || submitting )}" class="basket-button basket-button-to-step4 button btn-red">
					<span class="bank-label">{{ payment == 'bankPayment' ? 'Отримати рахунок' : 'Сплатити' }}</span>
				</div>
			</div>

		</div>
	</div>

	<div v-if="step == 4" class="checkoutStep4">
		<div class="checkoutStep4-content clearfix">
			<div class="checkout-summary"></div>
			<p class="checkoutStep3-title">Дякуємо за замовлення!</p>
			<div v-if="!demo">
			<p>Рахунок відправлено на Вашу електронну пошту. Ви можете сплатити його в будь-якому відділенні банку протягом 5 днів.</p>
			<p>Також Ви маєте змогу завантажити Ваш рахунок зараз.</p>
			<a :href="pdf" target="_blank" class="basket-button button btn-red download-bill-button">Завантажити рахунок</a>
			</div>
		</div>
	</div>

</template>
<script>

import { mapState } from 'vuex'
import { mapActions } from 'vuex'
import { mapMutations } from 'vuex'
import qs from 'qs'
import { each, filter, max, isEmpty, where, find } from 'underscore'
import axios from 'axios'
import $ from 'jquery'

export default {

  data: () => {
    return {
      step: 1,
      submitting: false,
      pdf: '',
      customerType: 'individual',
      customerName: '',
      customerName2: '',
      phone: '',
      email: '',
      organization: '',
      code: '',
      position: '',
      imStudent: false,
      studentsArray: [],
      comment: '',
      needBill: false,
      payment: 'cardPayment',
      delayTimer: null,
      validating: false,
      ajaxRequest: null,
      hasUnsellableItems: true,
      demo: false
    }
  },

  mounted() {
    if ( localStorage.studentsArray ) {
      this.studentsArray = JSON.parse(localStorage.studentsArray)
    }
    if ( localStorage.imStudent ) {
      this.imStudent = JSON.parse(localStorage.imStudent)
    }
    if ( localStorage.customerType ) {
    this.customerType = localStorage.customerType
    }
    if ( localStorage.customerName ) {
      this.customerName = localStorage.customerName
    }
    if ( localStorage.customerName2 ) {
      this.customerName2 = localStorage.customerName2
    }
    if ( localStorage.phone ) {
      this.phone = localStorage.phone
    }
    if ( localStorage.email ) {
      this.email = localStorage.email
    }
    if ( localStorage.organization ) {
      this.organization = localStorage.organization
    }
    if ( localStorage.code ) {
      this.code = localStorage.code
    }
    if ( localStorage.position ) {
      this.position = localStorage.position
    }
    if ( localStorage.comment ) {
      this.comment = localStorage.comment
    }
    if ( localStorage.needBill ) {
      this.needBill = JSON.parse(localStorage.needBill)
    }
    if ( localStorage.payment ) {
      this.payment = localStorage.payment
    }
  },

  watch: {

    studentsArray: {
      deep: true,
      handler () {
        localStorage.studentsArray = JSON.stringify(this.studentsArray)
      }
    },

    imStudent() {
      localStorage.imStudent = JSON.stringify(this.imStudent)
    },

    customerName() {
      localStorage.customerName = this.customerName
    },

		customerType() {
			if ( this.customerType == 'entity') {
				this.payment = 'bankPayment'
			}
			localStorage.customerType = this.customerType
		},

		customerName2() {
			localStorage.customerName2 = this.customerName2
		},

		phone() {
			localStorage.phone = this.phone
		},

		email() {
			localStorage.email = this.email
		},

		organization() {
			localStorage.organization = this.organization
		},

		code() {
			localStorage.code = this.code
		},

		position() {
			localStorage.position = this.position
		},

		comment() {
			localStorage.comment = this.comment
		},

		needBill() {
			localStorage.needBill = JSON.stringify(this.needBill)
		},

		payment() {
			localStorage.payment = this.payment
		},

		basketItems(){
			this.loadFullItems()
		},

		students () {
			var students = this.students
			if ( this.studentsArray.length ) {
				for (let i = 0; i < this.studentsArray.length; i++) {
					if ( typeof students[i] !== 'undefined' ) {
						this.studentsArray[i] = students[i]
					}
				}
			} else {
				for (let i = 0; i < this.studentsCount; i++) {
					this.studentsArray.push(students[i])
				}
			}
			if ( this.studentsArray.length < students.length ) {
				for (let i = this.studentsArray.length; i < this.studentsCount; i++) {
					this.studentsArray.push(students[i])
				}
			}
		}

  },

  computed: {
    ...mapState([
      'langcode',
      'basketItems',
      'fullItems',
    ]),

		customerTypeValid() {
			return this.customerType == 'individual' || this.customerType == 'entity'
		},
		customerNameValid() {
			return this.customerName.length > 0
		},
		customerName2Valid() {
			return this.customerName2.length > 0
		},
		phoneValid() {
			return this.phone.length > 0
		},
		emailValid() {
			const re = /^[^\s@]+@[^\s@]+$/
			return re.test(this.email)
		},
		organizationValid() {
			return ( this.customerType == 'entity' && this.organization.length > 0 ) || this.customerType == 'individual'
		},
		codeValid() {
			return ( this.customerType == 'entity' && this.code.length > 0 ) || this.customerType == 'individual'
		},
		positionValid() {
			return ( this.customerType == 'entity' && this.position.length > 0 ) || this.customerType == 'individual'
		},
		studentsArrayValid() {
			return !where(this.students, {valid: false}).length || !this.studentsCount
		},

		step2FormValid() {
			return (
				this.customerTypeValid &&
				this.customerNameValid &&
				this.customerName2Valid &&
				this.phoneValid &&
				this.emailValid &&
				this.organizationValid &&
				this.codeValid &&
				this.positionValid &&
				this.studentsArrayValid
			)
		},

		totalPrice() {
			var total = 0;
			each(this.fullItems, item => {
				total += item.quantity * item.price
			})
			return total
		},

		totalPdv() {
			var total = 0
			each(this.fullItems, item => {
				total += item.pdv ? Math.round( (item.quantity * item.price) / 6 ) : 0
			})
			return total
		},

		studentsCount() {
			let studyItems = filter( this.fullItems, item => item.selectedPrice == 'full' )
			let maxItem = max( studyItems, item => item.quantity )
			return isEmpty(maxItem) ? 0 : maxItem.quantity
		},

		students() {
			var students = [];
			if ( this.studentsCount ) {
				if ( this.studentsArray.length ) {
					for (let i = 0; i < this.studentsCount; i++) {
						let student = typeof this.studentsArray[i] !== 'undefined' ? this.studentsArray[i] : { name:'', valid: false }
						if ( this.imStudent && i == 0 ) {
							student.name = this.customerName + ' ' + this.customerName2
						}
						student.valid = student.name.length > 0
						students.push(student)
					}
				} else {
					for (let i = 0; i < this.studentsCount; i++) {
						let student = { name: '', valid: false }
						if ( this.imStudent && i == 0 ) {
							student.name = this.customerName + ' ' + this.customerName2
						}
						student.valid = student.name.length > 0
						students.push(student)
					}
				}
			}
			return students
		}

	},

	methods: {

    ...mapActions([
      'resetBasketItems'
    ]),

    ...mapMutations([
      'updateBasketItems',
      'updateFullItems'
    ]),

    getPeriodLabel(selectedPrice) {
      var label = '';
      switch ( selectedPrice ) {
        case 'print6':
        case 'jj6':
        case 'union6':
        case 'lite6':
        case 'start6':
        case 'max6':
          label = '6 місяців'
        break;
        case 'print12':
        case 'jj12':
        case 'union12':
        case 'lite12':
        case 'start12':
        case 'max12':
          label = '12 місяців'
        break;
      }
      return label
    },

		getTypeLabel(selectedPrice){
			var label = '';
			switch ( selectedPrice ) {
				case 'full':
					label = ''
				break
				case 'materials':
					label = 'Матеріали'
				break
        case 'video':
          label = 'Відео'
          break;
				case 'print6':
				case 'print12':
					label = 'Друкований журнал'
				break;
				case 'jj6':
				case 'jj12':
					label = 'Живий журнал'
				break;
				case 'union6':
				case 'union12':
					label = 'Друкований журнал + Живий журнал'
				break;
        case 'lite6':
        case 'lite12':
          label = 'Пакет Лайт'
          break;
        case 'start6':
        case 'start12':
          label = 'Пакет Стандарт'
          break;
        case 'max6':
        case 'max12':
          label = 'Пакет Максимум'
          break;
        case 'demo':
          label = 'Демо доступ'
          break;
			}
			return label
		},

		incQuantity(item) {
      let quantity = item.quantity
      item.quantity = ++quantity >= 99 ? 99 : quantity
			this.setQuantity(item);
    },
    decQuantity(item) {
      let quantity = item.quantity
      item.quantity = --quantity <= 1 ? 1 : quantity
			this.setQuantity(item);
    },

    loadFullItems() {
      axios.post('/basket/load',
      qs.stringify({
				langcode: this.langcode,
				items: this.basketItems
			}),
      {
        emulateJSON: true,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        }
      }
      ).then((response) => {
				this.updateFullItems(response.data)
        this.hasUnsellableItems = find( this.fullItems, item => !item.sellable) !== undefined
      })
    },

		removeFromBasket(item) {
      let data = {
        id: item.id,
        selectedPrice: item.selectedPrice,
      }
      axios.post('/basket/remove',
      qs.stringify(data),
      {
        emulateJSON: true,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
      }
      ).then((response) => {
        this.updateBasketItems(response.data)
      })

    },

		setQuantity(item) {
			if ( this.delayTimer ) {
				clearTimeout(this.delayTimer)
			}
			this.delayTimer = setTimeout(()=>{
				let data = {
					id: item.id,
					selectedPrice: item.selectedPrice,
					quantity: item.quantity,
				}
				if ( this.ajaxRequest ) {
					this.ajaxRequest.cancel()
				}
				this.ajaxRequest = axios.CancelToken.source()
				axios.post('/basket/quantity',
				qs.stringify(data),
				{
					cancelToken: this.ajaxRequest.token,
					emulateJSON: true,
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
					}
				}
				).then((response) => {
					this.ajaxRequest = null
					this.updateBasketItems(response.data)
				})
			}, 500)
    },

		gotoStep3() {
			this.validating = true;
			if ( this.step !== 4 && this.fullItems.length ) {
				if ( this.step2FormValid ) {
					this.validating = false;
					this.step = 3
				}
			}
		},

		submitOrder() {
			if ( this.fullItems.length && !this.submitting ) {
				this.submitting = true
				let data = {
					order: {
						customerType: this.customerType,
						customerName: this.customerName,
						customerName2: this.customerName2,
						phone: this.phone,
						email: this.email,
						organization: this.organization,
						code: this.code,
						position: this.position,
						imStudent: this.imStudent,
						students: this.students,
						comment: this.comment,
						needBill: this.needBill,
						payment: this.payment,
						items: this.fullItems,
						total: this.totalPrice,
						totalPdv: this.totalPdv
					}
				}
				axios.post('/basket/submit',
				qs.stringify(data),
				{
					emulateJSON: true,
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
					}
				}
				).then((response) => {
          this.resetBasketItems().then( () => {
            window.dataLayer.push({'event': 'form-sent', 'form-action': 'order'});
						if (response.data.liqpay.length) {
							var $form =$($.parseHTML(response.data.liqpay));
							$form.css('display', 'none');
							$('body').append($form);
							$form.submit();
						} else {
							this.step = 4
							this.submitting = false
							this.pdf = response.data.pdf
							if (!Number(response.data.total)) {
                this.demo = true
							}
						}
					}).catch( error => {
						console.info(error);
						alert('Виникла помилка. Оновіть сторінку та спробуйте ще.')
					})
				})
			}
    },

  }

}

</script>
